import { Routes, Route, useLocation } from 'react-router-dom';
import Layout from "../components/Layout";
import GuestLayout from '../components/GuestLayout';
import PageProtectedRoute from '../context/PageProtectedRoute';
import { AuthProvider } from '../context/AuthContext';
import PublicRoute from '../context/PublicRoute';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
// Items Menu
import Items from '../pages/items/Items';
import NewItem from '../pages/items/NewItem';
import ItemsBulkUpload from '../pages/items/ItemsBulkUpload';
import CategoryListItem from '../pages/items/CategoryList';
import Brands from '../pages/items/Brands';
import Units from '../pages/items/Units';
import Sizes from '../pages/items/Sizes';
import Sales from '../pages/Sales';
import CreateSaleMulti from '../pages/CreateSaleMulti';
import SalesList from '../pages/sales/SalesList';
import CreateSale from '../pages/sales/CreateSale';
import ViewSales from '../pages/sales/ViewSales';
import EditSale from '../pages/EditSale';
import Purchases from '../pages/Purchases';
import PurchasesList from '../pages/purchases/PurchasesList';
import CreatePurchases from '../pages/purchases/CreatePurchases';
import ViewPurchases from '../pages/purchases/ViewPurchases';
import EditPurchase from '../pages/EditPurchase';
import NewPurchase from '../pages/NewPurchase';
import ExpensesList from '../pages/expenses/ExpensesList';
import NewExpenses from '../pages/expenses/NewExpenses';
import CustomerList from '../pages/customers/CustomerList';
import NewCustomer from '../pages/customers/NewCustomer';
import CustomerImport from '../pages/customers/CustomerImport';
import SupplierList from '../pages/suppliers/SupplierList';
import NewSupplier from '../pages/suppliers/NewSupplier';
import Suppliers from '../pages/Suppliers';
import Accounts from '../pages/Accounts';
import AccountsSummary from '../pages/accounts/AccountsSummary';
import BankList from '../pages/accounts/BankList';
import NewBank from '../pages/accounts/NewBank';
import BankToBankLog from '../pages/accounts/BankToBankLog';
import AllTransactions from '../pages/accounts/AllTransactions';
import TransactionDetails from '../pages/accounts/TransactionDetails';
import Transactions from '../pages/BankTransactions';
import ProtectedRoute from '../components/ProtectedRoute';
import AccountLedger from '../pages/AccountLedger';
import AccountsLedger from '../pages/AccountsLedger';
import AccountSummary from '../pages/AccountSummary';
import SalesReport from '../pages/SalesReport';
import PurchaseReport from '../pages/PurchaseReport';
import ExpenseReport from '../pages/ExpenseReport';
import CategoryList from '../pages/expenses/CategoryList';
import NewCategory from '../pages/expenses/NewCategory';
import Colors from '../pages/items/Colors';
//Reports
import ProfitLossReport from '../pages/reports/ProfitLossReport';
import UnSoldItemReport from '../pages/reports/UnSoldItemReport';
import ItemStockReport from '../pages/reports/ItemStockReport';
import ReportsDashboard from '../pages/ReportsDashboard';
import SalesItemProfitSummary from '../pages/sales/SalesItemProfitSummary';
import BankTransfer from '../pages/BankTransfer';
import BankTransferLog from '../pages/BankTransferLog';
import Unauthorized from '../pages/Unauthorized';


//Users
import RoleList from '../pages/users/RoleList';
import UserList from '../pages/users/UserList';
import CreateUser from '../pages/users/CreateUser';

//Settings
import PageList from '../pages/settings/PageList';
import CreatePage from '../pages/settings/CreatePage';
import RolePermission from '../pages/settings/RolePermission';

function AppRoutes() {
    const location = useLocation();

    // Define routes that don't use Layout (guest)
    const guestRoutes = ["/", "/login", "/register", "/forgot-password"];

    const isGuestPage = guestRoutes.includes(location.pathname);

    const LayoutWrapper = isGuestPage ? GuestLayout : Layout;
    return (
        <LayoutWrapper>
            <Routes>
                <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
                <Route path="/" element={<PublicRoute><Login /></PublicRoute>} />
                <Route path="/unauthorized" element={<Unauthorized />} />
                <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/items" element={<PageProtectedRoute ><Items /></PageProtectedRoute>} />
                <Route path="/item/new" element={<PageProtectedRoute ><NewItem /></PageProtectedRoute>} />
                <Route path="/item/edit/:itemId" element={<PageProtectedRoute ><NewItem /></PageProtectedRoute>} />
                <Route path="/item/bulk" element={<PageProtectedRoute ><ItemsBulkUpload /></PageProtectedRoute>} />
                <Route path="/item/categories" element={<PageProtectedRoute ><CategoryListItem /></PageProtectedRoute>} />
                <Route path="/item/brands" element={<PageProtectedRoute ><Brands /></PageProtectedRoute>} />
                <Route path="/item/units" element={<PageProtectedRoute ><Units /></PageProtectedRoute>} />
                <Route path="/item/colors" element={<PageProtectedRoute ><Colors /></PageProtectedRoute>} />
                <Route path="/item/sizes" element={<PageProtectedRoute ><Sizes /></PageProtectedRoute>} />
                <Route path="/sales-list" element={<PageProtectedRoute ><SalesList /></PageProtectedRoute>} />
                <Route path="/sales/:id/edit" element={<PageProtectedRoute ><EditSale /></PageProtectedRoute>} />
                <Route path="/sales/new2" element={<PageProtectedRoute ><CreateSaleMulti /></PageProtectedRoute>} />
                <Route path="/sales/new" element={<PageProtectedRoute ><CreateSale /></PageProtectedRoute>} />
                <Route path="/sales/edit/:saleId" element={<PageProtectedRoute ><CreateSale /></PageProtectedRoute>} />
                <Route path="/sales/view/:saleId" element={<PageProtectedRoute pagePath="/sales/view/:saleId" ><ViewSales /></PageProtectedRoute>} />
                <Route path="/purchases-list" element={<PageProtectedRoute ><PurchasesList /></PageProtectedRoute>} />
                <Route path="/purchases/new" element={<PageProtectedRoute ><CreatePurchases /></PageProtectedRoute>} />
                <Route path="/purchases/new2" element={<PageProtectedRoute ><NewPurchase /></PageProtectedRoute>} />
                <Route path="/purchases/edit/:purchasesId" element={<PageProtectedRoute ><CreatePurchases /></PageProtectedRoute>} />
                <Route path="/purchases/view/:purchasesId" element={<PageProtectedRoute ><ViewPurchases /></PageProtectedRoute>} />
                <Route path="/expenses-list" element={<PageProtectedRoute ><ExpensesList /></PageProtectedRoute>} />
                <Route path="/expenses/new" element={<PageProtectedRoute ><NewExpenses /></PageProtectedRoute>} />
                <Route path="/expenses/edit/:expensesId" element={<PageProtectedRoute ><NewExpenses /></PageProtectedRoute>} />
                <Route path="/category-list" element={<PageProtectedRoute ><CategoryList /></PageProtectedRoute>} />
                <Route path="/category/new" element={<PageProtectedRoute ><NewCategory /></PageProtectedRoute>} />
                <Route path="/category/edit/:categoryId" element={<PageProtectedRoute ><NewCategory /></PageProtectedRoute>} />
                <Route path="/customers-list" element={<ProtectedRoute><CustomerList /></ProtectedRoute>} />
                <Route path="/customers/new" element={<ProtectedRoute><NewCustomer /></ProtectedRoute>} />
                <Route path="/customers/edit/:customerId" element={<ProtectedRoute><NewCustomer /></ProtectedRoute>} />
                <Route path="/customers/import" element={<ProtectedRoute><CustomerImport /></ProtectedRoute>} />
                <Route path="/suppliers-list" element={<ProtectedRoute><SupplierList /></ProtectedRoute>} />
                <Route path="/suppliers/new" element={<ProtectedRoute><NewSupplier /></ProtectedRoute>} />
                <Route path="/suppliers/edit/:suppliderId" element={<ProtectedRoute><NewSupplier /></ProtectedRoute>} />
                <Route path="/accounts" element={<PageProtectedRoute ><AccountsSummary /></PageProtectedRoute>} />
                <Route path="/account-ledger" element={<PageProtectedRoute ><AccountLedger /></PageProtectedRoute>} />
                <Route path="/accounts-ledger" element={<PageProtectedRoute ><AccountsLedger /></PageProtectedRoute>} />
                <Route path="/account-summary" element={<PageProtectedRoute ><AccountSummary /></PageProtectedRoute>} />
                <Route path="/banks-list" element={<PageProtectedRoute ><BankList /></PageProtectedRoute>} />
                <Route path="/banks/new" element={<PageProtectedRoute ><NewBank /></PageProtectedRoute>} />
                <Route path="/banks/edit/:bankId" element={<PageProtectedRoute ><NewBank /></PageProtectedRoute>} />
                <Route path="/sales-report" element={<PageProtectedRoute ><SalesReport /></PageProtectedRoute>} />
                <Route path="/purchase-report" element={<PageProtectedRoute ><PurchaseReport /></PageProtectedRoute>} />
                <Route path="/expense-report" element={<PageProtectedRoute ><ExpenseReport /></PageProtectedRoute>} />
                <Route path="/transactions" element={<PageProtectedRoute ><AllTransactions /></PageProtectedRoute>} />
                <Route path="/transactions/:transactionId" element={<PageProtectedRoute ><TransactionDetails /></PageProtectedRoute>} />
                <Route path="/sales-item-summary" element={<PageProtectedRoute ><SalesItemProfitSummary /></PageProtectedRoute>} />
                <Route path="/bank-transfer" element={<PageProtectedRoute ><BankTransfer /></PageProtectedRoute>} />
                <Route path="/bank-transfer-log" element={<PageProtectedRoute ><BankToBankLog /></PageProtectedRoute>} />
                <Route path="/profit-loss" element={<PageProtectedRoute ><ProfitLossReport /></PageProtectedRoute>} />
                <Route path="/item-stock-report" element={<PageProtectedRoute ><ItemStockReport /></PageProtectedRoute>} />
                <Route path="/unsold-items" element={<PageProtectedRoute ><UnSoldItemReport /></PageProtectedRoute>} />
                <Route path="/role-list" element={<PageProtectedRoute ><RoleList /></PageProtectedRoute>} />
                <Route path="/user-list" element={<PageProtectedRoute ><UserList /></PageProtectedRoute>} />
                <Route path="/create-user" element={<PageProtectedRoute ><CreateUser /></PageProtectedRoute>} />
                <Route path="/edit-user/:id" element={<PageProtectedRoute ><CreateUser /></PageProtectedRoute>} />
                <Route path="/page-list" element={<PageProtectedRoute ><PageList /></PageProtectedRoute>} />
                <Route path="/create-page" element={<PageProtectedRoute ><CreatePage /></PageProtectedRoute>} />
                <Route path="/edit-page/:pageId" element={<PageProtectedRoute ><CreatePage /></PageProtectedRoute>} />
                <Route path="/role-permission" element={<PageProtectedRoute ><RolePermission /></PageProtectedRoute>} />
            </Routes>
        </LayoutWrapper>
    );
}

export default AppRoutes;